import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import JobDetail from './JobDetail';
import JobList from './JobList';
import Page from '@/components/comm/Page';
import PageTitle from '@/components/comm/PageTitle';

const pageTitle = '채용정보';

const Jobs: NextPageWithAppProps = () => {
  const router = useRouter();
  const [id, setId] = useState<number | null>(null);
  const [page, setPage] = useState<number | null>(null);

  useEffect(() => {
    const { id, page } = router.query;
    setId(null);
    setPage(null);
    if (typeof id === 'string' && !Number.isNaN(Number(id))) {
      setId(Number(id));
    }
    if (typeof page === 'string' && !Number.isNaN(Number(page))) {
      setPage(Number(page));
    }
  }, [router.query]);

  return (
    <Page>
      <PageTitle title={pageTitle} />
      {id ? <JobDetail id={id} page={page} /> : <JobList page={page} />}
    </Page>
  );
};

export default Jobs;

Jobs.getPageProps = () => ({
  pageTitle,
});
